import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateAddUserEmployers = {
  addUserEmployers: { data: null, loading: false, error: null },
};

export const addUserEmployers = createAsyncThunk('user/addUserEmployers', async ({ userId, employers }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(
      `${process.env.REACT_APP_SERVER_API}/users/${userId}/employers`,
      { employers },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerAddUserEmployers = {
  [addUserEmployers.pending]: (state) => {
    state.addUserEmployers.data = null;
    state.addUserEmployers.loading = true;
    state.addUserEmployers.error = null;
  },
  [addUserEmployers.fulfilled]: (state, action) => {
    state.addUserEmployers.loading = false;
    state.addUserEmployers.data = true;
    state.addUserEmployers.error = null;
  },
  [addUserEmployers.rejected]: (state, action) => {
    state.addUserEmployers.data = null;
    state.addUserEmployers.loading = false;
    state.addUserEmployers.error = action.payload;
  },
};
